<template>
	<div>
		<div class="product">
			<div class="content flex align-center">
				<div class="banner">
					<div class="item" v-for="(item,index) in banner" @click="checkBanner(index)" :key="index">
						<img :src="imgBaseUrl+item" alt="">
					</div>
				</div>
				<div class="picture">
					<img :src="imgBaseUrl+bannerShow" alt="">
				</div>
				<div class="info">
					<div class="intro">{{detail.name}}</div>
					<div class="price flex align-center justify-between">
						<div class="money">£{{detail.goods_price}}</div>
						<div class="num flex align-center">
							<div class="del btn" @click="del">-</div>
							<div class="number">{{number}}</div>
							<div class="add btn" @click="add">+</div>
						</div>
					</div>
					<div class="btn_list flex align-center justify-between">
						<div class="btn" @click="addCart">Add to Basket</div>
						<div class="btn pay" @click="pay">Buy Now</div>
					</div>
				</div>
			</div>
		</div>
		<div class="menu">
			<div class="content flex align-center">
				<div class="item" :class="menuActive == 0 ? 'active' : ''">Product description</div>
				<!-- <div class="item" :class="menuActive == 1 ? 'active' : ''">商品评论</div> -->
			</div>
		</div>
		<div class="detail">
			<div class="content" v-if="menuActive == 0">
				<div v-html="detail.content"></div>
				<!-- <img src="../../../assets/images/home1.png" alt=""> -->
			</div>
			<div class="content" v-else>
				<div class="comment_list">
					<div class="item">
						<div class="userInfo flex align-center">
							<div class="photo">
								<img src="../../../assets/images/icon/photo.png" alt="">
							</div>
							<div class="name">李晓伟</div>
						</div>
						<div class="comment_info">
							<div class="info"></div>
							<div class="picture_list flex">
								<div class="picture">
									<img src="../../../assets/images/home1.png" alt="">
								</div>
							</div>
							<div class="comment_bottom flex align-center justify-between">
								<div class="time"></div>
								<div class="right_btn flex align-center">
									<div class="zan flex align-center">
										<span>18</span>
										<img src="../../../assets/images/icon/zan.png" alt="">
									</div>
									<div class="pinglun flex align-center">
										<span>26</span>
										<img src="../../../assets/images/icon/pinglun.png" alt="">
									</div>
									<img class="more" src="../../../assets/images/icon/more.png" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				banner:[],
				bannerShow:'',
				menuActive:0,
				id:'',
				detail:{},
				number:1
			}
		},
		created(){
			this.id = this.$route.query.id;
			this.getDetail()
		},
		methods:{
			del(){
				if(this.number > 1){
					this.number--
				}
			},
			add(){
				if(this.number < this.detail.stock){
					this.number++
				}
			},
			getDetail(){
				this.$api.post('goods/getGoodsDetails',{goods_id:this.id},res=>{
					if(res.code == 1){
						this.detail = res.data;
						this.banner = res.data.images.split(',')
						this.bannerShow = this.banner[0]
					}
				})
			},
			checkBanner(index){
				this.bannerShow = this.banner[index]
			},
			addCart(){
				var params = {
					num:this.number,
					goods_id:this.id
  				}
				this.$api.post('cart/add',params,res=>{
					if(res.code == 1){
						this.$message('add success')
						// this.$router.push({ path: '/home/cart', query: {type: 1}})
					}else{
						this.$message(res.msg)
					}
				})
			},
			pay(){
				this.$router.push({ path: '/home/pay', query: {id: this.id,num:this.number,type:0}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.product{
		width: 100%;
		padding-top: 40px;
		.content{
			width: 1200px;
			margin: 0 auto;
			.banner{
				width: 145px;
				height: 450px;
				overflow-y: scroll;
				margin-right: 15px;
				flex-shrink: 0;
				.item{
					width: 145px;
					height: 100px;
					overflow: hidden;
					margin-bottom: 15px;
					cursor: pointer;
					img{
						width: 100%;
						height: 100%;
					}
				}
			}
			.picture{
				width: 540px;
				height: 450px;
				overflow: hidden;
				margin-right: 40px;
				flex-shrink: 0;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.info{
				flex-grow: 1;
				.intro{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 40px;
				}
				.price{
					margin-top: 160px;
					.money{
						font-size: 30px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #BF5F49;
					}
					.num{
						width: 150px;
						height: 42px;
						border: 1px solid #888888;
						border-radius: 10px;
						line-height: 42px;
						font-size: 18px;
						font-family: PingFang SC;
						font-weight: 400;
						color: #020201;
						.btn{
							flex-grow: 1;
							text-align: center;
							cursor: pointer;
						}
						.number{
							width: 64px;
							flex-shrink: 0;
							text-align: center;
							border-right: 1px solid #959595;
							border-left:1px solid #959595;
						}
					}
				}
				.btn_list{
					margin-top: 30px;
					.btn{
						width: 200px;
						height: 57px;
						background: #282E30;
						border-radius: 29px;
						text-align: center;
						line-height: 57px;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #F7F2EB;
						cursor: pointer;
					}
					.pay{
						background: #5C707A;
					}
				}
			}
		}
	}
	.menu{
		margin-top: 50px;
		width: 100%;
		height: 100px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		.content{
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			.item{
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-right: 100px;
				&.active{
					color: #5C707A;
				}
			}
		}
	}
	.detail{
		width: 100%;
		padding-top: 30px;
		.content{
			width: 1200px;
			margin: 0 auto;
			.comment_list{
				.item{
					margin-bottom: 30px;
					padding-bottom: 20px;
					border-bottom: 1px solid #282E30;
					.userInfo{
						.photo{
							width: 80px;
							height: 80px;
							border-radius: 50%;
							overflow: hidden;
							margin-right: 20px;
							img{
								width: 100%;
								height: 100%;
							}
							.name{
								font-size: 24px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #282E30;
							}
						}
					}
					.comment_info{
						margin-top: 30px;
						.info{
							font-size: 20px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #282E30;
							line-height: 30px;
						}
						.picture_list{
							margin-top: 15px;
							flex-wrap: wrap;
							.picture{
								width: 468px;
								height: 247px;
								border-radius: 10px;
								overflow: hidden;
								margin-right: 20px;
								margin-bottom: 20px;
								img{
									width: 100%;
									height: 100%;
								}
							}
						}
						.comment_bottom{
							.time{
								font-size: 20px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #999999;
							}
							.right_btn{
								font-size: 20px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #999999;
								.zan{
									margin-right: 20px;
									img{
										width: 23px;
										height: 23px;
										margin-left: 12px;
									}
								}
								.pinglun{
									margin-right: 20px;
									img{
										width: 24px;
										height: 22px;
										margin-left: 12px;
									}
								}
								.more{
									width: 22px;
									height: 5px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>